import React from 'react';
import PropTypes from 'prop-types';
import ConfirmDialog from 'chameleon/ui-stack/ui/modals/confirm-dialog';

import './styles.scss';

const DeleteQuestionModal = ({ onCancel, onSubmit }) => {
  return (
    <ConfirmDialog
      title="Remove Question"
      onSuccess={onSubmit}
      onClose={onCancel}
      content={{
        btnPrimary: 'Remove',
        btnSecondary: 'Cancel',
      }}
    >
      <p>Are you sure you want to remove this question?</p>
    </ConfirmDialog>
  );
};

DeleteQuestionModal.displayName = 'DeleteQuestionModal';

DeleteQuestionModal.propTypes = {
  /**
   * What happens when teacher hits cancel.
   * */
  onCancel: PropTypes.func.isRequired,
  /**
   * What happens when teacher clicks "Remove"
   * */
  onSubmit: PropTypes.func.isRequired,
};

export default DeleteQuestionModal;
